import * as React from 'react';
import * as styles from './CarouselBlock.css';
import { clsx } from 'clsx';

export interface ICarouselBlockProps extends React.PropsWithChildren {
  logo?: React.ReactNode;
  features?: React.ReactNode;
  thumbnails?: React.ReactNode;
  isPromo?: boolean;
  labels: React.ReactNode;
  url?: string;
}

export const CarouselBlock: React.FC<ICarouselBlockProps> = ({
  children,
  features,
  isPromo,
  logo,
  labels,
  thumbnails,
  url,
}) => {
  return (
    <a
      className={clsx(styles['wrapper'], url && styles['is-link'], isPromo && styles['wrapper--promo'])}
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      <div data-testid="carousel" className={clsx(styles['container'], isPromo && styles['container--promo'])}>
        {children}
        {features && <div className={styles['features']}>{features}</div>}
        {logo && <div className={styles['logo']}>{logo}</div>}
        {labels}
      </div>
      {thumbnails && <div className={styles['thumbnails']}>{thumbnails}</div>}
    </a>
  );
};
